import { createAction, props } from '@ngrx/store';
import { ResponseClientExternalIdentity, RequestClientExternalIdentity } from '../../shared/interfaces';
import { ClientExternalIdentityTypes } from '../../shared/enums';


export const getClientExternalIdentity = createAction(
    ClientExternalIdentityTypes.CLIENT_EXTERNAL_IDENTITY,
    props<{ request: RequestClientExternalIdentity}>()
);

export const getClientExternalIdentitySucess = createAction(
    ClientExternalIdentityTypes.CLIENT_EXTERNAL_IDENTITY_SUCCESS,
    props<{ response: ResponseClientExternalIdentity }>()
);

export const getClientExternalIdentityError = createAction(
    ClientExternalIdentityTypes.CLIENT_EXTERNAL_IDENTITY_ERROR,
    props<{ payload: any }>()
);

export const cleanState = createAction(
    ClientExternalIdentityTypes.CLEAN_STATE
);
